module.exports = __webpack_public_path__ + "img/pdf-file.d74a9f95.svg";